import React, { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/pro-solid-svg-icons";

// One tile per deeplink. The label sits at the bottom over a dark fade so it stays
// readable on any photo; without a usable image the tile is text only.
const StayOnlyTile = ({ image, label, icon, onClick }) => {
    const [imageFailed, setImageFailed] = useState(false);
    const showImage = !!image && !imageFailed;

    return (
        <button
            type="button"
            className={`stay-only-tile ${showImage ? "" : "text-only"}`}
            onClick={onClick}
        >
            {showImage && (
                <img
                    className="stay-only-tile-image"
                    src={image}
                    alt=""
                    onError={() => setImageFailed(true)}
                />
            )}
            <span className="stay-only-tile-label">
                {icon && (
                    <FontAwesomeIcon
                        className="stay-only-tile-icon"
                        icon={icon}
                    />
                )}
                <span>{label}</span>
            </span>
        </button>
    );
};

StayOnlyTile.propTypes = {
    image: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.object,
    onClick: PropTypes.func,
};

// Stay-only (hotel-only) replies have no hotel listing yet, so instead of the
// carousel they show two image tiles that open the hotel list and map deeplinks.
const StayOnlyTiles = ({ messageData, T, onOpen }) => {
    const tiles = [
        {
            type: "search",
            link: messageData?.deeplinkList,
            image: messageData?.hotelImage1,
            label: T("Chat:Explore_All_Stays"),
        },
        {
            type: "map",
            link: messageData?.deeplinkMap,
            image: messageData?.hotelImage2,
            label: T("Packages_Detail:Show_On_Map"),
            icon: faLocationDot,
        },
    ].filter((tile) => tile.link);

    if (!tiles.length) return null;

    return (
        <div className="stay-only-tiles">
            {tiles.map((tile) => (
                <StayOnlyTile
                    key={tile.type}
                    image={tile.image}
                    label={tile.label}
                    icon={tile.icon}
                    onClick={() => onOpen(tile.type)}
                />
            ))}
        </div>
    );
};

StayOnlyTiles.propTypes = {
    messageData: PropTypes.shape({
        deeplinkList: PropTypes.string,
        deeplinkMap: PropTypes.string,
        hotelImage1: PropTypes.string,
        hotelImage2: PropTypes.string,
    }),
    T: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
};

export default StayOnlyTiles;
